import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { TaskComment } from 'application/schedule/components';

function TaskCommentsModalTemplate({ taskCommentsModalStore }) {
    const {
        item
    } = taskCommentsModalStore;
    return (
        <section>
                <div className="row">
                    <div className="col u-mar--bottom--tny">
                        <h4>{item.taskName}</h4>
                    </div>
                </div>
                {item && <TaskComment facilityScheduleDateId={item.facilityScheduleDateId} scroll={false}/>}
        </section> 
    );
    
}

TaskCommentsModalTemplate.propTypes = {
    taskCommentsModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(TaskCommentsModalTemplate);
